@singleton()
export class ConfigProvider {
  getPublicRuntimeConfig() {
    return useRuntimeConfig().public;
  }
}
